import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ConceptContactModel } from './conceptcontact.model';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../../models/base';

const LIST_ENDPOINT = '/conceptcontact';

interface ApiMessageResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConceptContactService {
  conceptList: ConceptContactModel[] = [];

  constructor(private http: HttpClient) {}

  getList(): Promise<ConceptContactModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<ConceptContactModel[]>>(environment.apiUrl + LIST_ENDPOINT)
    ).then((response) => response.data);
  }

  getListByContact(uid: string): Promise<ConceptContactModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<ConceptContactModel[]>>(
        environment.apiUrl + LIST_ENDPOINT + '/contact/' + uid
      )
    ).then((response) => response.data);
  }

  addData(concept: ConceptContactModel): Promise<ConceptContactModel> {
    return firstValueFrom(
      this.http.post<ApiResponse<ConceptContactModel>>(environment.apiUrl + LIST_ENDPOINT, concept)
    ).then((response) => response.data);
  }

  editData(uid: string, concept: ConceptContactModel): Promise<ConceptContactModel> {
    return firstValueFrom(
      this.http.put<ApiResponse<ConceptContactModel>>(
        environment.apiUrl + LIST_ENDPOINT + `/${uid}`,
        concept
      )
    ).then((response) => response.data);
  }

  deleteData(uid: string): Promise<string> {
    return firstValueFrom(
      this.http.delete<ApiMessageResponse>(environment.apiUrl + LIST_ENDPOINT + `/${uid}`)
    ).then((response) => response.message);
  }

  loadData(uid: string): Promise<ConceptContactModel> {
    return firstValueFrom(
      this.http.get<ApiResponse<ConceptContactModel>>(environment.apiUrl + LIST_ENDPOINT + `/${uid}`)
    ).then((response) => response.data);
  }
}